import { createContext } from 'react';
import type { AppearanceConfig } from './appearance';
import type { AppTheme } from './index';
export const AppearanceContext = createContext<AppearanceConfig | null>(null);
export const AppearancePreviewContext = createContext<AppTheme | null>(null);

export const AppearanceTypographyContext = createContext<AppTheme['typography']>({ family: 'system', scale: 1, letterSpacing: 0 });
